import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { timeRanges } from "../../constances";

//
import { getCoinInfo } from "../../redux/features/coins/actions";

//
import Forms from "../../components/alert-report/Forms";
import Report from "../../components/alert-report/Report";

function AlertReport({ coins }) {
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState(null);

  //
  const [activeCoin, setActiveCoin] = useState({});
  const [timeRange, setTimeRange] = useState({
    name: "",
    value: "",
  });

  // convert time range
  const convertRange = (key) => {
    return timeRange.value[key].format("YYYY-MM-DD");
  };

  /**
   * Get Coin Info
   */
  const get_coin_info = async () => {
    let coin = activeCoin.symbol;
    let time = timeRange.value;

    if (time && coin) {
      // start loading
      setLoading(true);

      // set variables
      let dateFrom = convertRange("start");
      let dateTo = convertRange("end");
      let symbol = coin.toLowerCase();

      // request
      await getCoinInfo({ symbol, dateFrom, dateTo }).then((res) => {
        if (res) {
          setReports(res);
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  return (
    <div id="alert-report" className={reports ? "full" : ""}>
      {!reports ? (
        <Forms
          coins={coins}
          activeCoin={activeCoin}
          setActiveCoin={(filter) => setActiveCoin(filter)}
          loading={loading}
          timeRanges={timeRanges}
          timeRange={timeRange}
          setTimeRange={(range) => setTimeRange(range)}
          getCoinInfo={() => get_coin_info()}
        />
      ) : (
        <Report
          reports={reports}
          coins={coins}
          activeCoin={activeCoin}
          setActiveCoin={(filter) => setActiveCoin(filter)}
          loading={loading}
          timeRanges={timeRanges}
          timeRange={timeRange}
          setTimeRange={(range) => setTimeRange(range)}
          getCoinInfo={() => get_coin_info()}
        />
      )}
    </div>
  );
}

AlertReport.propTypes = {
  coins: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  coins: state.coinsReducer.coins,
});

export default connect(mapStateToProps)(AlertReport);
